import { useState, useEffect } from "react";

import { toast } from "sonner";
import { getValidationStats,getValidationCounts,getUrgentValidations } from "../api/validationService";

export const useValidationStats = (accountId, domainId) => {
  const [stats, setStats] = useState(null);
  const [counts, setCounts] = useState(null);
  const [urgent, setUrgent] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!accountId || !domainId) return;

    const fetchStats = async () => {
      try {
        setLoading(true);
        setError(null);

        // On récupère tout en parallèle pour de meilleures perfs
        const [statsData, countsData, urgentData] = await Promise.all([
          getValidationStats(accountId, domainId),
          getValidationCounts(accountId, domainId),
          getUrgentValidations(accountId, domainId),
        ]);

        setStats(statsData);
        setCounts(countsData);
        setUrgent(urgentData);
      } catch (err) {
        toast.error("Erreur lors du chargement des stats:", err);
        setError("Impossible de charger les statistiques");
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, [accountId, domainId]);

  return { stats, counts, urgent, loading, error };
};
